import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Button } from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import Header from '../../components/Header';
import { LoadingBar } from '../../components/util/LoadingBar';
import {
  MTAssumptionsSection,
  MTCalc,
  MTCTAv2,
  MTDivider,
  MTHeader,
  MTLearnMore,
  MTLearnMoreItem,
  MTScorePanel,
  MTSkinny,
  MTSubcontent,
  MTSubcontentH1,
  MTSubcontentH2,
  MTSubcontentHR,
  MTSubcontentLabel,
  MTSubcontentP,
  MTSubheading,
  MTWide,
} from '../Microtools/layout';
import { CustomCTA } from '../Onboarding/PlanIntro';

import { runFullSimulation } from '../../actions/simulationActions';
import { trackEvent } from '../../actions/trackEventActions';
import { updateFrame } from '../../actions/uiActions';
import { wlPath, wlVar } from '../../helpers/whitelabel';

// for some reason Chrome on Windows needs a bit of extra height (hence +15px)
const IFrameContainer = styled.div`
  position: relative;
  overflow: hidden;
  height: ${props => (props.height ? `${props.height + 15}px` : '100%')};
`;

const StyledIFrame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${props => `${props.height}px` || '100%'};
  border: 0;
`;

export class PayOrSave extends Component {
  constructor(props) {
    super(props);
    this.state = {
      iFrameHeight: undefined,
    };
  }

  componentDidMount() {
    this.props.updateFrame('Should you be paying off your debt, or saving?', 'creditcards.jpg');
    // if (!this.props.results) {
    //   this.props.runFullSimulation();
    // }

    // wait for iFrame to load
    this.checkIfIFrameLoaded();
    //window.addEventListener('resize', this.updateIFrameHeight);
  }

  checkIfIFrameLoaded = () => {
    const iFrame = document.getElementById('calc-iframe');
    const iFrameDoc = iFrame.contentDocument || iFrame.contentWindow.document;
    if (iFrameDoc.readyState === 'complete' && iFrameDoc.getElementsByTagName('body').length) {
      // add a listener that will update the height if it's changed
      this.onElementHeightChange(iFrame, this.updateIFrameHeight);
      this.updateIFrameHeight();
      return;
    }
    window.setTimeout(this.checkIfIFrameLoaded, 100);
  };

  onElementHeightChange = (el, callback) => {
    let lastHeight = el.contentWindow.document.getElementsByTagName('body')[0].scrollHeight;
    let newHeight;
    (function run() {
      if (el.contentWindow.document.getElementsByTagName('body').length) {
        newHeight = el.contentWindow.document.getElementsByTagName('body')[0].scrollHeight;
        if (lastHeight != newHeight) {
          callback();
        }
      }

      lastHeight = newHeight;

      if (el.onElementHeightChangeTimer) {
        clearTimeout(el.onElementHeightChangeTimer);
      }

      el.onElementHeightChangeTimer = setTimeout(run, 200);
    })();
  };

  updateIFrameHeight = () => {
    this.setState({
      iFrameHeight: this.getIFrameHeight(),
    });
  };

  getIFrameHeight = () => {
    const newiFrameHeight = document
      .getElementById('calc-iframe')
      .contentWindow.document.getElementsByTagName('body')[0].scrollHeight;
    return newiFrameHeight;
  };

  componentWillUnmount() {
    //window.removeEventListener('resize', this.updateIFrameHeight);
  }

  render() {
    const { results } = this.props;

    if (!results) {
      return <LoadingBar />;
    }

    return (
      <div>
        <MTHeader title="" />
        <MTSkinny>
          <MTSubcontent noCard>
            <MTSubcontentP>
              If you have multiple kinds of debt, and multiple kinds of savings account, where should your money go
              first?
            </MTSubcontentP>
          </MTSubcontent>
          <MTSubheading title="Use this tool to help you prioritize your options." />
          <MTSubcontent noCard>
            <MTSubcontentP>
              Choosing the right thing to focus on now can be tricky. Despite our best instincts, sometimes it’s not
              always best to be 100% debt free.
            </MTSubcontentP>
          </MTSubcontent>
          <MTSubcontent noCard>
            <MTSubcontentP>
              This tool takes some basic information about your situation, then it gives you an initial idea of what you
              might want to prioritize now.
            </MTSubcontentP>
          </MTSubcontent>
          <MTSubcontent noCard>
            <MTSubcontentP>
              <strong>
                Give the tool a try! If you have a unique situation that you’re not sure about, feel free to get in
                touch.
              </strong>
            </MTSubcontentP>
          </MTSubcontent>

          {/* placeholder for iframe */}
          <IFrameContainer height={this.state.iFrameHeight}>
            <StyledIFrame id="calc-iframe" src="/calculators/payorsave" height={this.state.iFrameHeight} />
          </IFrameContainer>

          <MTSubcontent noCard>
            <MTSubcontentP>
              Remember, this tool is just a starting point using basic information. If you’re excited to start tackling
              your debt, make sure you have a thorough financial plan that includes all your financial goals!
            </MTSubcontentP>
          </MTSubcontent>
        </MTSkinny>
        <CustomCTA heading="We’re here to help you get your debt on track" trackEvent={this.props.trackEvent}>
          <Typography
            tag="div"
            use="body1"
            className="pt-2"
            theme={wlVar('white_header') ? 'text-primary-on-light' : 'on-primary'}
          >
            Knowing where to focus is a great starting point. But debt management requires a good budget, and a
            financial plan that factors in your other financial goals. It’s easier when you have back-up. Schedule a
            free intro and to learn how we can help you tackle your debt.
          </Typography>
        </CustomCTA>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    results: state.simulations.results,
  };
}

export default connect(mapStateToProps, { runFullSimulation, trackEvent, updateFrame })(PayOrSave);
